import axios from 'axios';

const eLearningBaseURL = process.env.VUE_APP_API_BASE_URL_ELEARNING;
const doctorBaseURL = process.env.VUE_APP_API_BASE_URL_DOCTOR;
const appealsBaseUrl = process.env.VUE_APP_API_BASE_URL_APPEALS;

// Validate the environment variables
if (!eLearningBaseURL || !doctorBaseURL || !appealsBaseUrl) {
  console.error('Missing environment variables:', {
    VUE_APP_API_BASE_URL_ELEARNING: eLearningBaseURL,
    VUE_APP_API_BASE_URL_DOCTOR: doctorBaseURL,
    VUE_APP_API_BASE_URL_APPEALS: appealsBaseUrl,

  });
  throw new Error('API base URLs must be defined in .env');
}

const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

export const setApiSystem = (system) => {
  if (!['eLearning', 'hmis', 'rafiki360', 'appeals'].includes(system)) {
    console.warn(`Invalid system: ${system}, defaulting to eLearning`);
    system = 'eLearning';
  }
  api.defaults.baseURL = system === 'eLearning' ? eLearningBaseURL : (system === 'appeals' ? appealsBaseUrl : doctorBaseURL);
  api.defaults.system = system;
  console.log(`API baseURL set to: ${api.defaults.baseURL} for system: ${system}`);
};

api.interceptors.request.use(
  (config) => {
    let system = config.system || api.defaults.system || 'eLearning';
    if (!['eLearning', 'hmis', 'rafiki360', 'appeals'].includes(system)) {
      console.warn(`Invalid system: ${system}, defaulting to eLearning`);
      system = 'eLearning';
    }
    config.baseURL = system === 'eLearning' ? eLearningBaseURL : (system === 'appeals' ? appealsBaseUrl : doctorBaseURL);
    const token = localStorage.getItem(`${system}_token`); // System-specific token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log(`Request to ${config.url} (system: ${system}) with token: Bearer ${token.substring(0, 10)}...`);
    } else {
      console.warn(`No token found for system ${system} for request to ${config.url}`);
    }
    config.system = system;
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => {
    console.log(`Response from ${response.config.url} (system: ${response.config.system}): ${response.status}`);
    return response;
  },
  (error) => {
    console.error('Response error:', error.response?.status || 'unknown', error.response?.data?.message || error.message);
    return Promise.reject(error);
  },
);

export default api;